/* eslint-disable react-hooks/exhaustive-deps */
import "./product-summary.scss"

import React, { useState, useEffect } from "react"

import Input from "components/Input/Input"

import AddToCart from "components/AddToCart/AddToCart"
import LazyPlaceholder from "components/LazyPlaceholder/LazyPlaceholder"
import usePrivateDeliveryNotice from "hooks/usePrivateDeliveryNotice"
import { PRIVATE_DELIVERY_NOTICE_PENDING_NOTE } from "utils/privateDeliveryNotice"

import IcoEnvelope from "assets/images/ico-product-summary-envelope.svg"
import IcoCheck from "assets/images/ico-product-summary-check.svg"
import IcoClose from "assets/images/ico-product-summary-close.svg"

const ProductSummary = ({
  setModal,
  data,
  cartConfirmation,
  setCartConfirmation,
  setIsAddedToCart,
  productPrivate,
}) => {
  const [quantity, setQuantity] = useState(1)
  const [apiStockStatus, setApiStockStatus] = useState(1)
  const [apiLoading, setApiLoading] = useState(true)
  const deliveryNoticePending = usePrivateDeliveryNotice()

  useEffect(() => {
    fetch(
      `https://woo.memtech.pl/wp-json/woo-custom/v1/stock-quantity/${data.databaseId}`
    )
      .then(res => res.json())
      .then(response => {
        setApiStockStatus(response.stock_quantity)
        setApiLoading(false)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  return (
    <div className="product-summary">
      {apiLoading ? (
        <LazyPlaceholder />
      ) : (
        <>
          {(data?.salePrice && (data?.regularPrice !== data?.price)) ? (
            <div>
              <p className="product-summary__strike">{data?.regularPrice}</p>
              <h3 className="product-summary__promo">{data?.price}</h3>
              <p className="product-summary__omnibus">
                Najniższa cena z 30 dni przed obniżką:{" "}
                <span>{data?.lowestPrice}</span>
              </p>
            </div>
          ) : (
            <div>
              <h3>{data?.price}</h3>
            </div>
          )}
          <div className="product-summary__row">
            <Input
              type="number"
              name="quantity"
              label="szt"
              value={quantity}
              onChange={e =>
                setQuantity(
                  e.target.value <= 0
                    ? (e.target.value = e.target.value * -1)
                    : e.target.value
                )
              }
              step="1"
              min="1"
              required
            />
            <AddToCart
              product={data}
              quantity={quantity}
              onClick={() => setIsAddedToCart(true)}
              cartConfirmation={cartConfirmation}
              setCartConfirmation={setCartConfirmation}
              disabled={
                quantity <= 0 || (quantity > apiStockStatus && "disabled")
              }
            />
          </div>
          {deliveryNoticePending && (
            <p className="mt-3">{PRIVATE_DELIVERY_NOTICE_PENDING_NOTE}</p>
          )}
          <div className="product-summary__leasing">
            <a
              href="https://leaselink.pl/shortH/co/63c7b0"
              target="_blank"
              rel="noreferrer"
              className="button button--bordered"
            >
              <span>Leasing</span>
            </a>
          </div>
          <div className="product-summary__info">
            {apiStockStatus > 0 ? (
              <>
                <p>
                  <img src={IcoCheck} alt="" />
                  Dostępna ilość: {apiStockStatus && apiStockStatus} szt.
                </p>
                {!productPrivate && (
                  <p>
                    <img src={IcoCheck} alt="" />
                    Darmowa dostawa
                  </p>
                )}
                <p>
                  <img src={IcoCheck} alt="" />
                  Dostawa za {productPrivate ? "7" : "2"} dni
                </p>
              </>
            ) : (
              <p>
                <img src={IcoClose} alt="" />
                Produkt niedostępny
              </p>
            )}
          </div>
          <a
            className="product-summary__cta"
            href="/"
            onClick={e => {
              e.preventDefault()
              setModal(true)
            }}
          >
            <img src={IcoEnvelope} alt="" />
            Zapytaj o produkt
          </a>
        </>
      )}
    </div>
  )
}

export default ProductSummary
